import { render, staticRenderFns } from "./PageActionBar.vue?vue&type=template&id=a4f438f8&"
import script from "./PageActionBar.vue?vue&type=script&lang=ts&"
export * from "./PageActionBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports